module.exports = __webpack_public_path__ + "static/media/START_LOADING_NEXT_CONTAINER.e82a53f1.svg";